/**
 * Timing constants for consistent UX throughout the application
 * These values define standard durations for animations, delays, and timeouts
 */

// Animation durations (in milliseconds)
export const ANIMATION_DURATION = {
  FAST: 200,     // Quick transitions, achievement toast stagger
  MEDIUM: 300,   // Standard animations, modal close delays
  SLOW: 800,     // Longer animations, confetti display, smooth scrolling
};

// User feedback delays (in milliseconds)
export const FEEDBACK_DELAY = {
  AUTH_REDIRECT: 1500,  // Time to show status before redirecting after auth
  SUCCESS_MESSAGE: 1500, // Duration to show success messages
  AUTO_CLOSE: 5000,      // Default auto-close delay for toasts
};

// Development/testing timeouts (in milliseconds)
export const DEV_TIMEOUT = {
  TEST_ADVANCE: 200,  // Time advancement in tests
};

// Commonly used individual values for backward compatibility
export const ACHIEVEMENT_TOAST_STAGGER_DELAY = ANIMATION_DURATION.FAST;
export const ANIMATION_CLOSE_DELAY = ANIMATION_DURATION.MEDIUM;
export const CONFETTI_DISPLAY_DURATION = ANIMATION_DURATION.SLOW;
export const AUTH_REDIRECT_DELAY = FEEDBACK_DELAY.AUTH_REDIRECT;
export const SUCCESS_MESSAGE_DURATION = FEEDBACK_DELAY.SUCCESS_MESSAGE;
export const TOAST_AUTO_CLOSE_DELAY = FEEDBACK_DELAY.AUTO_CLOSE;